import { graphql, useStaticQuery } from "gatsby";
import { CollectionPage, StringValue } from "../types";
const scientistLinks = require("../../normalizers/scientistLinks.js");

export interface ScientistLinkPage {
  letter: string;
  links: {
    url: string;
    title: string;
    year: string;
  }[];
}

export interface UseScientistLinks {
  pages: CollectionPage[];
  firstPage: ScientistLinkPage;
  labels: {
    label: string;
    disabled?: boolean;
  }[];
}

export interface ScientistLinksQuery {
  allPaginatedCollection: {
    nodes: {
      pages: (CollectionPage & { nodes: any })[];
      pageCount: number;
    }[];
  };
  paginatedCollectionPage: {
    nodes: {
      letter: string;
      links: {
        url: string;
        title: string;
        year: string;
      }[];
    }[];
  };
}

export const useScientistLinks = (): UseScientistLinks => {
  const scientistLinkData = useStaticQuery<ScientistLinksQuery>(graphql`
    query ScientistLinkPagesQuery {
      allPaginatedCollection(filter: { name: { eq: "scientistLinks" } }) {
        nodes {
          pages {
            id
            hasNextPage
            index
            nodes
          }
          pageCount
        }
      }
      paginatedCollectionPage(
        collection: {
          name: { eq: "scientistLinks" }
          pages: { elemMatch: { index: { eq: 0 } } }
        }
      ) {
        nodes
      }
    }
  `);

  const sortedPages =
    scientistLinkData.allPaginatedCollection?.nodes[0]?.pages.sort(
      (left, right) => left.index - right.index
    );

  const pages = sortedPages.map((page) => ({
    id: page.id,
    hasNextPage: page.hasNextPage,
    index: page.index,
  }));

  const labels = sortedPages.map((page) => {
    let label = page.nodes[0].letter;
    let disabled;

    if (page.nodes[0].links.length === 0) {
      disabled = true;
    }

    if (label === "numbers") {
      label = "#";
    }

    return { label, disabled };
  });

  const firstPage = scientistLinkData.paginatedCollectionPage?.nodes[0];

  return { pages, firstPage, labels };
};
